export default __webpack_public_path__ + "static/lower2_3-b969689e8f30e97cc14ca053d4bb52f4.jpg";